function Footer() {
    const links = [
        { name: "GitHub", url: "https://github.com/yahyamomtaz" },
        { name: "LinkedIn", url: "https://www.linkedin.com/in/yahya-momtaz-601b34108/" },
        { name: "Kaggle", url: "https://www.kaggle.com/yahyamomtaz" },
    ];

    return (
        <footer className="w-full border-t border-[var(--border)]">
            <div className="site-container footer-container flex flex-col sm:flex-row items-center justify-between">
                <p className="text-xs text-zinc-600">© 2026 Yahya Momtaz</p>
                <div className="flex items-center gap-5">
                    {links.map(({ name, url }) => (
                        <a
                            key={name}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-zinc-600 hover:text-zinc-300 transition-colors"
                        >
                            {name}
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}

export default Footer;
